module.exports = __webpack_public_path__ + "img/qyxc_icon.75dfd094.png";